import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Remove loading screen
const loader = document.querySelector('.app-loader');
if (loader) {
  loader.style.opacity = '0';
  loader.style.transition = 'opacity 0.3s ease';
  setTimeout(() => loader.remove(), 300);
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


